export default {"src":"/_next/static/media/my-favorites-toast-gray-heart.8ba6dec6.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};